"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {
    spring: '#26b431',
    'dark-spring': '#22a12c',
    sky: '#1ebff0',
    'dark-sky': '#35aad8',
    ocean: '#2375df',
    stardust: '#7333aa',
    fire: '#e7323a',
    'dark-fire': '#cf2c34',
    sunset: '#e85b86',
    'dark-sunset': '#d05178',
    sunrise: '#f9a90c',
    'dark-sunrise': '#df970a',
    white: '#ffffff',
    chalk: '#fafafa',
    lightest: '#e8e9ea',
    lighter: '#d3d4d6',
    light: '#a6a9ae',
    dark: '#7a7f85',
    darker: '#4d545d',
    space: '#212934',
    'dark-space': '#1c232c',
    // Old Colors for global-nav
    black: '#000000',
    ash: '#999',
    nimbus: '#85939e',
    // Color Uses
    action: 'dark-sky',
    neutral: 'light',
    success: 'spring',
    caution: 'sunrise',
    error: 'fire',
    info: 'action'
};
exports.default = colors;
//# sourceMappingURL=colors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/services/colors.js
// module id = 201
// module chunks = 0